// tslint:disable-next-line:variable-name
export const HttpUtils = {
  getJsonContentTypeHeader() {
    return {
      headers: { 'Content-Type': 'application/json' },
    };
  },
};
